import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cc5a2c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-time-ago text-xs p-1 pr-2 pl-2 border-round-xl text-white inline-block mb-1" }

import { computed } from "vue";
import { useTimeAgo, useDateFormat } from "@vueuse/core";
import { get } from "@vueuse/core";
import {
  DATE_ISO_FORMAT,
  CURRENT_DATE_JP,
  PREVIOUS_DATE_JP,
  DATE_IN_MONTH_FORMAT,
  DATE_IN_YEAR_FORMAT,
  DATE_IN_PREVIOUS_YEAR_FORMAT,
} from "@/clinic/typings/constants/direct-message";

type IMessageTimeAgo = {
  date: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'time-ago',
  props: {
    date: null
  },
  setup(__props: any) {

const props = __props as {
  date: string;
};

const showTimeAgo = computed((): string =>
  get(
    useTimeAgo(useDateFormat(props.date || new Date(), DATE_ISO_FORMAT), {
      fullDateFormatter: (date: Date) => date.toLocaleDateString(),
      messages: {
        justNow: CURRENT_DATE_JP,
        past: (n: any) => n,
        future: (n: any) => n,
        month: () => `${get(useDateFormat(props.date, DATE_IN_MONTH_FORMAT, { locales: "ja" }))}`,
        year: (n: number) => {
          const format = n == 1 ? DATE_IN_YEAR_FORMAT : DATE_IN_PREVIOUS_YEAR_FORMAT;
          return `${get(useDateFormat(props.date, format, { locales: "ja" }))}`;
        },
        day: (n: number) => {
          return n === 1
            ? PREVIOUS_DATE_JP
            : `${get(useDateFormat(props.date, DATE_IN_MONTH_FORMAT, { locales: "ja" }))}`;
        },
        week: (n: number) => {
          return `${get(useDateFormat(props.date, DATE_IN_MONTH_FORMAT, { locales: "ja" }))}`;
        },
        hour: () => CURRENT_DATE_JP,
        minute: () => CURRENT_DATE_JP,
        second: () => CURRENT_DATE_JP,
        invalid: "invalid",
      },
    })
  )
);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(showTimeAgo)), 1))
}
}

})